@file:OptIn(InternalResourceApi::class)

package thewedding_cmp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/thewedding_cmp.composeapp.generated.resources/"

@delegate:ResourceContentHash(-166_842_443)
internal val Res.string.collectionLabelDiscovered: StringResource by lazy {
      StringResource("string:collectionLabelDiscovered", "collectionLabelDiscovered", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 25985, 73),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11589, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12277, 57),
      ))
    }

@delegate:ResourceContentHash(1_778_542_120)
internal val Res.string.collectionPopupResetConfirm: StringResource by lazy {
      StringResource("string:collectionPopupResetConfirm", "collectionPopupResetConfirm", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26059, 195),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11647, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12335, 99),
      ))
    }

@delegate:ResourceContentHash(-2_067_668_246)
internal val Res.string.collectionTitleCollection: StringResource by lazy {
      StringResource("string:collectionTitleCollection", "collectionTitleCollection", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26255, 57),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11731, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12435, 49),
      ))
    }

@delegate:ResourceContentHash(516_365_854)
internal val Res.string.colosseum1140ce: StringResource by lazy {
      StringResource("string:colosseum1140ce", "colosseum1140ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26313, 543),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11773, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12485, 191),
      ))
    }

@delegate:ResourceContentHash(1_620_969_713)
internal val Res.string.colosseum1490ce: StringResource by lazy {
      StringResource("string:colosseum1490ce", "colosseum1490ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 26857, 435),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 11945, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12677, 171),
      ))
    }

@delegate:ResourceContentHash(-450_271_511)
internal val Res.string.colosseum1829ce: StringResource by lazy {
      StringResource("string:colosseum1829ce", "colosseum1829ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27293, 575),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 12093, 215),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12849, 235),
      ))
    }

@delegate:ResourceContentHash(-539_959_195)
internal val Res.string.colosseum1990ce: StringResource by lazy {
      StringResource("string:colosseum1990ce", "colosseum1990ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 27869, 663),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 12309, 223),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13085, 271),
      ))
    }

@delegate:ResourceContentHash(24_212_713)
internal val Res.string.colosseum70ce: StringResource by lazy {
      StringResource("string:colosseum70ce", "colosseum70ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 28533, 705),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 12533, 241),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13357, 301),
      ))
    }

@delegate:ResourceContentHash(98_415_766)
internal val Res.string.colosseum82ce: StringResource by lazy {
      StringResource("string:colosseum82ce", "colosseum82ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29239, 369),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 12775, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13659, 137),
      ))
    }

@delegate:ResourceContentHash(-653_716_848)
internal val Res.string.colosseumArtifactCulture: StringResource by lazy {
      StringResource("string:colosseumArtifactCulture", "colosseumArtifactCulture", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29609, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 12901, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13797, 40),
      ))
    }

@delegate:ResourceContentHash(-2_006_881_484)
internal val Res.string.colosseumArtifactGeolocation: StringResource by lazy {
      StringResource("string:colosseumArtifactGeolocation", "colosseumArtifactGeolocation", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29658, 92),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 12946, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13838, 52),
      ))
    }

@delegate:ResourceContentHash(-1_055_451_638)
internal val Res.string.colosseumCallout1: StringResource by lazy {
      StringResource("string:colosseumCallout1", "colosseumCallout1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 29751, 813),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 12999, 245),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13891, 273),
      ))
    }

@delegate:ResourceContentHash(-155_813_553)
internal val Res.string.colosseumCallout2: StringResource by lazy {
      StringResource("string:colosseumCallout2", "colosseumCallout2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 30565, 465),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 13245, 189),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14165, 205),
      ))
    }

@delegate:ResourceContentHash(24_172_908)
internal val Res.string.colosseumCollectible1Icon: StringResource by lazy {
      StringResource("string:colosseumCollectible1Icon", "colosseumCollectible1Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31031, 45),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 13435, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14371, 41),
      ))
    }

@delegate:ResourceContentHash(-648_423_952)
internal val Res.string.colosseumCollectible1Title: StringResource by lazy {
      StringResource("string:colosseumCollectible1Title", "colosseumCollectible1Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31077, 130),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 13477, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14413, 70),
      ))
    }

@delegate:ResourceContentHash(-1_548_861_282)
internal val Res.string.colosseumCollectible2Icon: StringResource by lazy {
      StringResource("string:colosseumCollectible2Icon", "colosseumCollectible2Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31208, 61),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 13540, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14484, 41),
      ))
    }

@delegate:ResourceContentHash(1_574_600_381)
internal val Res.string.colosseumCollectible2Title: StringResource by lazy {
      StringResource("string:colosseumCollectible2Title", "colosseumCollectible2Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31270, 182),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 13582, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14526, 90),
      ))
    }

@delegate:ResourceContentHash(116_452_027)
internal val Res.string.colosseumCollectible3Icon: StringResource by lazy {
      StringResource("string:colosseumCollectible3Icon", "colosseumCollectible3Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31453, 53),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 13661, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14617, 45),
      ))
    }

@delegate:ResourceContentHash(-1_228_061_706)
internal val Res.string.colosseumCollectible3Title: StringResource by lazy {
      StringResource("string:colosseumCollectible3Title", "colosseumCollectible3Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31507, 106),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 13703, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14663, 62),
      ))
    }

@delegate:ResourceContentHash(-533_119_257)
internal val Res.string.colosseumConstructionInfo1: StringResource by lazy {
      StringResource("string:colosseumConstructionInfo1", "colosseumConstructionInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 31614, 1642),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 13790, 702),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14726, 682),
      ))
    }

@delegate:ResourceContentHash(1_791_371_156)
internal val Res.string.colosseumConstructionInfo2: StringResource by lazy {
      StringResource("string:colosseumConstructionInfo2", "colosseumConstructionInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 33257, 462),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 14493, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15409, 210),
      ))
    }

@delegate:ResourceContentHash(-1_331_087_822)
internal val Res.string.colosseumHistoryInfo1: StringResource by lazy {
      StringResource("string:colosseumHistoryInfo1", "colosseumHistoryInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 33720, 581),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 14672, 249),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15620, 281),
      ))
    }

@delegate:ResourceContentHash(-1_074_011_789)
internal val Res.string.colosseumHistoryInfo2: StringResource by lazy {
      StringResource("string:colosseumHistoryInfo2", "colosseumHistoryInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 34302, 1293),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 14922, 409),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15902, 553),
      ))
    }

@delegate:ResourceContentHash(1_907_270_660)
internal val Res.string.colosseumLocationInfo1: StringResource by lazy {
      StringResource("string:colosseumLocationInfo1", "colosseumLocationInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 35596, 1126),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 15332, 426),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16456, 430),
      ))
    }

@delegate:ResourceContentHash(-1_194_564_024)
internal val Res.string.colosseumLocationInfo2: StringResource by lazy {
      StringResource("string:colosseumLocationInfo2", "colosseumLocationInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 36723, 462),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 15759, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16887, 214),
      ))
    }

@delegate:ResourceContentHash(-393_731_058)
internal val Res.string.colosseumMapCaption: StringResource by lazy {
      StringResource("string:colosseumMapCaption", "colosseumMapCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 37186, 203),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 15946, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17102, 95),
      ))
    }

@delegate:ResourceContentHash(1_772_652_127)
internal val Res.string.colosseumPullQuote1Bottom: StringResource by lazy {
      StringResource("string:colosseumPullQuote1Bottom", "colosseumPullQuote1Bottom", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 37390, 109),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16050, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17198, 77),
      ))
    }

@delegate:ResourceContentHash(1_578_182_612)
internal val Res.string.colosseumPullQuote1Top: StringResource by lazy {
      StringResource("string:colosseumPullQuote1Top", "colosseumPullQuote1Top", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 37500, 102),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16112, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17276, 66),
      ))
    }

@delegate:ResourceContentHash(-1_630_983_687)
internal val Res.string.colosseumPullQuote2: StringResource by lazy {
      StringResource("string:colosseumPullQuote2", "colosseumPullQuote2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 37681, 251),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16221, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17393, 127),
      ))
    }

@delegate:ResourceContentHash(1_596_122_457)
internal val Res.string.colosseumPullQuote2Author: StringResource by lazy {
      StringResource("string:colosseumPullQuote2Author", "colosseumPullQuote2Author", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 37603, 77),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16179, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17343, 49),
      ))
    }

@delegate:ResourceContentHash(1_535_157_679)
internal val Res.string.colosseumRegionTitle: StringResource by lazy {
      StringResource("string:colosseumRegionTitle", "colosseumRegionTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 37933, 60),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16357, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17521, 44),
      ))
    }

@delegate:ResourceContentHash(1_696_634_828)
internal val Res.string.colosseumSubTitle: StringResource by lazy {
      StringResource("string:colosseumSubTitle", "colosseumSubTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 37994, 73),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16414, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17566, 49),
      ))
    }

@delegate:ResourceContentHash(1_041_926_510)
internal val Res.string.colosseumTitle: StringResource by lazy {
      StringResource("string:colosseumTitle", "colosseumTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 38068, 54),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16460, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17616, 34),
      ))
    }

@delegate:ResourceContentHash(-717_517_022)
internal val Res.string.colosseumVideoCaption: StringResource by lazy {
      StringResource("string:colosseumVideoCaption", "colosseumVideoCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 38123, 337),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16503, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17651, 145),
      ))
    }

@delegate:ResourceContentHash(635_981_504)
internal val Res.string.eightWaySemanticSwipeDetector: StringResource by lazy {
      StringResource("string:eightWaySemanticSwipeDetector", "eightWaySemanticSwipeDetector", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 38461, 121),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16625, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17797, 69),
      ))
    }

@delegate:ResourceContentHash(1_911_842_054)
internal val Res.string.eraClassical: StringResource by lazy {
      StringResource("string:eraClassical", "eraClassical", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 38583, 72),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16691, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17867, 40),
      ))
    }

@delegate:ResourceContentHash(886_065_714)
internal val Res.string.eraEarlyModern: StringResource by lazy {
      StringResource("string:eraEarlyModern", "eraEarlyModern", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 38656, 98),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16728, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17908, 46),
      ))
    }

@delegate:ResourceContentHash(-1_124_046_455)
internal val Res.string.eraModern: StringResource by lazy {
      StringResource("string:eraModern", "eraModern", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 38755, 57),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16767, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17955, 33),
      ))
    }

@delegate:ResourceContentHash(649_021_944)
internal val Res.string.eraPrehistory: StringResource by lazy {
      StringResource("string:eraPrehistory", "eraPrehistory", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 38813, 89),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16793, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17989, 37),
      ))
    }

@delegate:ResourceContentHash(1_638_783_641)
internal val Res.string.eventsListButtonOpenGlobal: StringResource by lazy {
      StringResource("string:eventsListButtonOpenGlobal", "eventsListButtonOpenGlobal", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 38903, 118),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16831, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18027, 62),
      ))
    }

@delegate:ResourceContentHash(1_199_655_591)
internal val Res.string.expandingTimeSelectorSemanticSelector: StringResource by lazy {
      StringResource("string:expandingTimeSelectorSemanticSelector", "expandingTimeSelectorSemanticSelector", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 39022, 109),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16898, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18090, 73),
      ))
    }

@delegate:ResourceContentHash(1_608_551_372)
internal val Res.string.fullscreenImageViewerSemanticFull: StringResource by lazy {
      StringResource("string:fullscreenImageViewerSemanticFull", "fullscreenImageViewerSemanticFull", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 39132, 185),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 16972, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18164, 101),
      ))
    }

@delegate:ResourceContentHash(-925_867_864)
internal val Res.string.greatWall121bce: StringResource by lazy {
      StringResource("string:greatWall121bce", "greatWall121bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 39318, 871),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 17058, 307),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18266, 319),
      ))
    }

@delegate:ResourceContentHash(674_503_280)
internal val Res.string.greatWall1487ce: StringResource by lazy {
      StringResource("string:greatWall1487ce", "greatWall1487ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 40190, 635),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 17366, 183),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18586, 267),
      ))
    }

@delegate:ResourceContentHash(1_265_228_777)
internal val Res.string.greatWall214bce: StringResource by lazy {
      StringResource("string:greatWall214bce", "greatWall214bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 40826, 619),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 17550, 211),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18854, 287),
      ))
    }

@delegate:ResourceContentHash(209_250_206)
internal val Res.string.greatWall556ce: StringResource by lazy {
      StringResource("string:greatWall556ce", "greatWall556ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 41446, 830),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 17762, 242),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19142, 310),
      ))
    }

@delegate:ResourceContentHash(-1_459_325_958)
internal val Res.string.greatWall618ce: StringResource by lazy {
      StringResource("string:greatWall618ce", "greatWall618ce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 42277, 642),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 18005, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19453, 262),
      ))
    }

@delegate:ResourceContentHash(-667_317_359)
internal val Res.string.greatWall700bce: StringResource by lazy {
      StringResource("string:greatWall700bce", "greatWall700bce", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 42920, 719),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 18184, 215),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19716, 283),
      ))
    }

@delegate:ResourceContentHash(643_578_015)
internal val Res.string.greatWallArtifactCulture: StringResource by lazy {
      StringResource("string:greatWallArtifactCulture", "greatWallArtifactCulture", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 43640, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 18400, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20000, 44),
      ))
    }

@delegate:ResourceContentHash(-1_037_515_974)
internal val Res.string.greatWallArtifactGeolocation: StringResource by lazy {
      StringResource("string:greatWallArtifactGeolocation", "greatWallArtifactGeolocation", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 43689, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 18441, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20045, 44),
      ))
    }

@delegate:ResourceContentHash(-968_578_840)
internal val Res.string.greatWallCallout1: StringResource by lazy {
      StringResource("string:greatWallCallout1", "greatWallCallout1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 43738, 245),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 18486, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20090, 133),
      ))
    }

@delegate:ResourceContentHash(1_277_542_049)
internal val Res.string.greatWallCallout2: StringResource by lazy {
      StringResource("string:greatWallCallout2", "greatWallCallout2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 43984, 437),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 18588, 205),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20224, 205),
      ))
    }

@delegate:ResourceContentHash(588_971_644)
internal val Res.string.greatWallCollectible1Icon: StringResource by lazy {
      StringResource("string:greatWallCollectible1Icon", "greatWallCollectible1Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 44422, 61),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 18794, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20430, 41),
      ))
    }

@delegate:ResourceContentHash(-1_035_612_445)
internal val Res.string.greatWallCollectible1Title: StringResource by lazy {
      StringResource("string:greatWallCollectible1Title", "greatWallCollectible1Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 44484, 154),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 18836, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20472, 86),
      ))
    }

@delegate:ResourceContentHash(24_172_908)
internal val Res.string.greatWallCollectible2Icon: StringResource by lazy {
      StringResource("string:greatWallCollectible2Icon", "greatWallCollectible2Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 44639, 45),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 18899, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20559, 41),
      ))
    }

@delegate:ResourceContentHash(2_046_414_634)
internal val Res.string.greatWallCollectible2Title: StringResource by lazy {
      StringResource("string:greatWallCollectible2Title", "greatWallCollectible2Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 44685, 94),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 18941, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20601, 54),
      ))
    }

@delegate:ResourceContentHash(573_104_081)
internal val Res.string.greatWallCollectible3Icon: StringResource by lazy {
      StringResource("string:greatWallCollectible3Icon", "greatWallCollectible3Icon", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 44780, 53),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 18984, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20656, 45),
      ))
    }

@delegate:ResourceContentHash(110_806_700)
internal val Res.string.greatWallCollectible3Title: StringResource by lazy {
      StringResource("string:greatWallCollectible3Title", "greatWallCollectible3Title", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 44834, 142),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 19026, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20702, 78),
      ))
    }

@delegate:ResourceContentHash(-671_778_015)
internal val Res.string.greatWallConstructionInfo1: StringResource by lazy {
      StringResource("string:greatWallConstructionInfo1", "greatWallConstructionInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 44977, 1110),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 19089, 274),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20781, 454),
      ))
    }

@delegate:ResourceContentHash(203_040_582)
internal val Res.string.greatWallConstructionInfo2: StringResource by lazy {
      StringResource("string:greatWallConstructionInfo2", "greatWallConstructionInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 46088, 922),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 19364, 306),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21236, 394),
      ))
    }

@delegate:ResourceContentHash(819_292_459)
internal val Res.string.greatWallHistoryInfo1: StringResource by lazy {
      StringResource("string:greatWallHistoryInfo1", "greatWallHistoryInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 47011, 937),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 19671, 305),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21631, 417),
      ))
    }

@delegate:ResourceContentHash(-1_383_831_918)
internal val Res.string.greatWallHistoryInfo2: StringResource by lazy {
      StringResource("string:greatWallHistoryInfo2", "greatWallHistoryInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 47949, 933),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 19977, 369),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22049, 425),
      ))
    }

@delegate:ResourceContentHash(-1_202_543_791)
internal val Res.string.greatWallLocationInfo1: StringResource by lazy {
      StringResource("string:greatWallLocationInfo1", "greatWallLocationInfo1", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 48883, 1054),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 20347, 290),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22475, 430),
      ))
    }

@delegate:ResourceContentHash(81_165_890)
internal val Res.string.greatWallLocationInfo2: StringResource by lazy {
      StringResource("string:greatWallLocationInfo2", "greatWallLocationInfo2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 49938, 750),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 20638, 278),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22906, 354),
      ))
    }

@delegate:ResourceContentHash(774_856_922)
internal val Res.string.greatWallMapCaption: StringResource by lazy {
      StringResource("string:greatWallMapCaption", "greatWallMapCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 50689, 243),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 20917, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23261, 111),
      ))
    }

@delegate:ResourceContentHash(-1_481_539_147)
internal val Res.string.greatWallPullQuote1Bottom: StringResource by lazy {
      StringResource("string:greatWallPullQuote1Bottom", "greatWallPullQuote1Bottom", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 50933, 97),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21001, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23373, 65),
      ))
    }

@delegate:ResourceContentHash(58_564_593)
internal val Res.string.greatWallPullQuote1Top: StringResource by lazy {
      StringResource("string:greatWallPullQuote1Top", "greatWallPullQuote1Top", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 51031, 110),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21051, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23439, 58),
      ))
    }

@delegate:ResourceContentHash(-830_954_504)
internal val Res.string.greatWallPullQuote2: StringResource by lazy {
      StringResource("string:greatWallPullQuote2", "greatWallPullQuote2", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 51208, 291),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21192, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23540, 147),
      ))
    }

@delegate:ResourceContentHash(908_956_122)
internal val Res.string.greatWallPullQuote2Author: StringResource by lazy {
      StringResource("string:greatWallPullQuote2Author", "greatWallPullQuote2Author", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 51142, 65),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21106, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23498, 41),
      ))
    }

@delegate:ResourceContentHash(-1_037_515_974)
internal val Res.string.greatWallRegionTitle: StringResource by lazy {
      StringResource("string:greatWallRegionTitle", "greatWallRegionTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 51500, 40),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21340, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23688, 36),
      ))
    }

@delegate:ResourceContentHash(1_167_936_869)
internal val Res.string.greatWallSubTitle: StringResource by lazy {
      StringResource("string:greatWallSubTitle", "greatWallSubTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 51541, 121),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21377, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23725, 61),
      ))
    }

@delegate:ResourceContentHash(-718_795_593)
internal val Res.string.greatWallTitle: StringResource by lazy {
      StringResource("string:greatWallTitle", "greatWallTitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 51663, 66),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21435, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23787, 42),
      ))
    }

@delegate:ResourceContentHash(-1_563_841_284)
internal val Res.string.greatWallVideoCaption: StringResource by lazy {
      StringResource("string:greatWallVideoCaption", "greatWallVideoCaption", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 51730, 441),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21474, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23830, 181),
      ))
    }

@delegate:ResourceContentHash(1_602_236_366)
internal val Res.string.homeMenuAboutApp: StringResource by lazy {
      StringResource("string:homeMenuAboutApp", "homeMenuAboutApp", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 52172, 56),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21620, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24012, 44),
      ))
    }

@delegate:ResourceContentHash(1_060_213_069)
internal val Res.string.homeMenuAboutBuilt: StringResource by lazy {
      StringResource("string:homeMenuAboutBuilt", "homeMenuAboutBuilt", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 52229, 142),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21665, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24057, 74),
      ))
    }

@delegate:ResourceContentHash(-332_719_290)
internal val Res.string.homeMenuAboutFlutter: StringResource by lazy {
      StringResource("string:homeMenuAboutFlutter", "homeMenuAboutFlutter", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 52372, 48),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21740, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24132, 40),
      ))
    }

@delegate:ResourceContentHash(1_067_425_289)
internal val Res.string.homeMenuAboutGskinner: StringResource by lazy {
      StringResource("string:homeMenuAboutGskinner", "homeMenuAboutGskinner", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 52421, 61),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21781, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24173, 41),
      ))
    }

@delegate:ResourceContentHash(935_826_963)
internal val Res.string.homeMenuAboutLearn: StringResource by lazy {
      StringResource("string:homeMenuAboutLearn", "homeMenuAboutLearn", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 52483, 78),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21823, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24215, 54),
      ))
    }

@delegate:ResourceContentHash(398_625_385)
internal val Res.string.homeMenuAboutMet: StringResource by lazy {
      StringResource("string:homeMenuAboutMet", "homeMenuAboutMet", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 52562, 172),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21894, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24270, 80),
      ))
    }

@delegate:ResourceContentHash(-1_725_459_847)
internal val Res.string.homeMenuAboutPhotography: StringResource by lazy {
      StringResource("string:homeMenuAboutPhotography", "homeMenuAboutPhotography", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 52735, 92),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 21959, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24351, 64),
      ))
    }

@delegate:ResourceContentHash(1_177_811_476)
internal val Res.string.homeMenuAboutPublic: StringResource by lazy {
      StringResource("string:homeMenuAboutPublic", "homeMenuAboutPublic", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 52828, 147),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22024, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24416, 71),
      ))
    }

@delegate:ResourceContentHash(2_122_276_372)
internal val Res.string.homeMenuAboutRepo: StringResource by lazy {
      StringResource("string:homeMenuAboutRepo", "homeMenuAboutRepo", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 52976, 105),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22104, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24488, 53),
      ))
    }

@delegate:ResourceContentHash(-1_429_200_002)
internal val Res.string.homeMenuAboutSource: StringResource by lazy {
      StringResource("string:homeMenuAboutSource", "homeMenuAboutSource", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 53082, 203),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22166, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24542, 107),
      ))
    }

@delegate:ResourceContentHash(-809_139_262)
internal val Res.string.homeMenuAboutUnsplash: StringResource by lazy {
      StringResource("string:homeMenuAboutUnsplash", "homeMenuAboutUnsplash", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 53286, 65),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22274, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24650, 41),
      ))
    }

@delegate:ResourceContentHash(2_141_841_821)
internal val Res.string.homeMenuAboutWonderous: StringResource by lazy {
      StringResource("string:homeMenuAboutWonderous", "homeMenuAboutWonderous", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 53352, 202),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22316, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24692, 114),
      ))
    }

@delegate:ResourceContentHash(-1_161_829_756)
internal val Res.string.homeMenuButtonAbout: StringResource by lazy {
      StringResource("string:homeMenuButtonAbout", "homeMenuButtonAbout", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 53555, 87),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22411, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24807, 47),
      ))
    }

@delegate:ResourceContentHash(-1_733_401_847)
internal val Res.string.homeMenuButtonExplore: StringResource by lazy {
      StringResource("string:homeMenuButtonExplore", "homeMenuButtonExplore", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 53643, 117),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22471, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24855, 57),
      ))
    }

@delegate:ResourceContentHash(-68_520_791)
internal val Res.string.homeMenuButtonView: StringResource by lazy {
      StringResource("string:homeMenuButtonView", "homeMenuButtonView", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 53761, 90),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22525, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24913, 54),
      ))
    }

@delegate:ResourceContentHash(-366_617_410)
internal val Res.string.homeSemanticOpenMain: StringResource by lazy {
      StringResource("string:homeSemanticOpenMain", "homeSemanticOpenMain", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 53852, 88),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22576, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24968, 48),
      ))
    }

@delegate:ResourceContentHash(-1_310_906_155)
internal val Res.string.homeSemanticWonder: StringResource by lazy {
      StringResource("string:homeSemanticWonder", "homeSemanticWonder", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 53941, 42),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22625, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25017, 34),
      ))
    }

@delegate:ResourceContentHash(830_528_914)
internal val Res.string.introDescriptionLearn: StringResource by lazy {
      StringResource("string:introDescriptionLearn", "introDescriptionLearn", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 53984, 345),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22660, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25052, 129),
      ))
    }

@delegate:ResourceContentHash(-1_610_987_022)
internal val Res.string.introDescriptionNavigate: StringResource by lazy {
      StringResource("string:introDescriptionNavigate", "introDescriptionNavigate", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 54330, 188),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22742, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25182, 104),
      ))
    }

@delegate:ResourceContentHash(-1_744_841_129)
internal val Res.string.introDescriptionUncover: StringResource by lazy {
      StringResource("string:introDescriptionUncover", "introDescriptionUncover", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 54519, 239),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22835, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25287, 115),
      ))
    }

@delegate:ResourceContentHash(-2_058_069_072)
internal val Res.string.introSemanticEnterApp: StringResource by lazy {
      StringResource("string:introSemanticEnterApp", "introSemanticEnterApp", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 54759, 93),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22923, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25403, 49),
      ))
    }

@delegate:ResourceContentHash(1_901_476_523)
internal val Res.string.introSemanticNavigate: StringResource by lazy {
      StringResource("string:introSemanticNavigate", "introSemanticNavigate", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 54853, 77),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 22977, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25453, 41),
      ))
    }

@delegate:ResourceContentHash(1_531_010_798)
internal val Res.string.introSemanticSwipeLeft: StringResource by lazy {
      StringResource("string:introSemanticSwipeLeft", "introSemanticSwipeLeft", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 54931, 146),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23015, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25495, 62),
      ))
    }

@delegate:ResourceContentHash(-1_313_217_829)
internal val Res.string.introSemanticWonderous: StringResource by lazy {
      StringResource("string:introSemanticWonderous", "introSemanticWonderous", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 55078, 50),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23082, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25558, 42),
      ))
    }

@delegate:ResourceContentHash(-1_482_324_522)
internal val Res.string.introTitleDiscover: StringResource by lazy {
      StringResource("string:introTitleDiscover", "introTitleDiscover", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 55129, 106),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23125, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25601, 50),
      ))
    }

@delegate:ResourceContentHash(993_787_515)
internal val Res.string.introTitleExplore: StringResource by lazy {
      StringResource("string:introTitleExplore", "introTitleExplore", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 55236, 101),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23168, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25652, 45),
      ))
    }

@delegate:ResourceContentHash(-285_867_462)
internal val Res.string.introTitleJourney: StringResource by lazy {
      StringResource("string:introTitleJourney", "introTitleJourney", setOf(
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 55338, 77),
        ResourceItem(setOf(LanguageQualifier("zh"), ), "${MD}values-zh/strings.commonMain.cvr", 23218, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25698, 53),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("collectionLabelDiscovered", Res.string.collectionLabelDiscovered)
  map.put("collectionPopupResetConfirm", Res.string.collectionPopupResetConfirm)
  map.put("collectionTitleCollection", Res.string.collectionTitleCollection)
  map.put("colosseum1140ce", Res.string.colosseum1140ce)
  map.put("colosseum1490ce", Res.string.colosseum1490ce)
  map.put("colosseum1829ce", Res.string.colosseum1829ce)
  map.put("colosseum1990ce", Res.string.colosseum1990ce)
  map.put("colosseum70ce", Res.string.colosseum70ce)
  map.put("colosseum82ce", Res.string.colosseum82ce)
  map.put("colosseumArtifactCulture", Res.string.colosseumArtifactCulture)
  map.put("colosseumArtifactGeolocation", Res.string.colosseumArtifactGeolocation)
  map.put("colosseumCallout1", Res.string.colosseumCallout1)
  map.put("colosseumCallout2", Res.string.colosseumCallout2)
  map.put("colosseumCollectible1Icon", Res.string.colosseumCollectible1Icon)
  map.put("colosseumCollectible1Title", Res.string.colosseumCollectible1Title)
  map.put("colosseumCollectible2Icon", Res.string.colosseumCollectible2Icon)
  map.put("colosseumCollectible2Title", Res.string.colosseumCollectible2Title)
  map.put("colosseumCollectible3Icon", Res.string.colosseumCollectible3Icon)
  map.put("colosseumCollectible3Title", Res.string.colosseumCollectible3Title)
  map.put("colosseumConstructionInfo1", Res.string.colosseumConstructionInfo1)
  map.put("colosseumConstructionInfo2", Res.string.colosseumConstructionInfo2)
  map.put("colosseumHistoryInfo1", Res.string.colosseumHistoryInfo1)
  map.put("colosseumHistoryInfo2", Res.string.colosseumHistoryInfo2)
  map.put("colosseumLocationInfo1", Res.string.colosseumLocationInfo1)
  map.put("colosseumLocationInfo2", Res.string.colosseumLocationInfo2)
  map.put("colosseumMapCaption", Res.string.colosseumMapCaption)
  map.put("colosseumPullQuote1Bottom", Res.string.colosseumPullQuote1Bottom)
  map.put("colosseumPullQuote1Top", Res.string.colosseumPullQuote1Top)
  map.put("colosseumPullQuote2", Res.string.colosseumPullQuote2)
  map.put("colosseumPullQuote2Author", Res.string.colosseumPullQuote2Author)
  map.put("colosseumRegionTitle", Res.string.colosseumRegionTitle)
  map.put("colosseumSubTitle", Res.string.colosseumSubTitle)
  map.put("colosseumTitle", Res.string.colosseumTitle)
  map.put("colosseumVideoCaption", Res.string.colosseumVideoCaption)
  map.put("eightWaySemanticSwipeDetector", Res.string.eightWaySemanticSwipeDetector)
  map.put("eraClassical", Res.string.eraClassical)
  map.put("eraEarlyModern", Res.string.eraEarlyModern)
  map.put("eraModern", Res.string.eraModern)
  map.put("eraPrehistory", Res.string.eraPrehistory)
  map.put("eventsListButtonOpenGlobal", Res.string.eventsListButtonOpenGlobal)
  map.put("expandingTimeSelectorSemanticSelector", Res.string.expandingTimeSelectorSemanticSelector)
  map.put("fullscreenImageViewerSemanticFull", Res.string.fullscreenImageViewerSemanticFull)
  map.put("greatWall121bce", Res.string.greatWall121bce)
  map.put("greatWall1487ce", Res.string.greatWall1487ce)
  map.put("greatWall214bce", Res.string.greatWall214bce)
  map.put("greatWall556ce", Res.string.greatWall556ce)
  map.put("greatWall618ce", Res.string.greatWall618ce)
  map.put("greatWall700bce", Res.string.greatWall700bce)
  map.put("greatWallArtifactCulture", Res.string.greatWallArtifactCulture)
  map.put("greatWallArtifactGeolocation", Res.string.greatWallArtifactGeolocation)
  map.put("greatWallCallout1", Res.string.greatWallCallout1)
  map.put("greatWallCallout2", Res.string.greatWallCallout2)
  map.put("greatWallCollectible1Icon", Res.string.greatWallCollectible1Icon)
  map.put("greatWallCollectible1Title", Res.string.greatWallCollectible1Title)
  map.put("greatWallCollectible2Icon", Res.string.greatWallCollectible2Icon)
  map.put("greatWallCollectible2Title", Res.string.greatWallCollectible2Title)
  map.put("greatWallCollectible3Icon", Res.string.greatWallCollectible3Icon)
  map.put("greatWallCollectible3Title", Res.string.greatWallCollectible3Title)
  map.put("greatWallConstructionInfo1", Res.string.greatWallConstructionInfo1)
  map.put("greatWallConstructionInfo2", Res.string.greatWallConstructionInfo2)
  map.put("greatWallHistoryInfo1", Res.string.greatWallHistoryInfo1)
  map.put("greatWallHistoryInfo2", Res.string.greatWallHistoryInfo2)
  map.put("greatWallLocationInfo1", Res.string.greatWallLocationInfo1)
  map.put("greatWallLocationInfo2", Res.string.greatWallLocationInfo2)
  map.put("greatWallMapCaption", Res.string.greatWallMapCaption)
  map.put("greatWallPullQuote1Bottom", Res.string.greatWallPullQuote1Bottom)
  map.put("greatWallPullQuote1Top", Res.string.greatWallPullQuote1Top)
  map.put("greatWallPullQuote2", Res.string.greatWallPullQuote2)
  map.put("greatWallPullQuote2Author", Res.string.greatWallPullQuote2Author)
  map.put("greatWallRegionTitle", Res.string.greatWallRegionTitle)
  map.put("greatWallSubTitle", Res.string.greatWallSubTitle)
  map.put("greatWallTitle", Res.string.greatWallTitle)
  map.put("greatWallVideoCaption", Res.string.greatWallVideoCaption)
  map.put("homeMenuAboutApp", Res.string.homeMenuAboutApp)
  map.put("homeMenuAboutBuilt", Res.string.homeMenuAboutBuilt)
  map.put("homeMenuAboutFlutter", Res.string.homeMenuAboutFlutter)
  map.put("homeMenuAboutGskinner", Res.string.homeMenuAboutGskinner)
  map.put("homeMenuAboutLearn", Res.string.homeMenuAboutLearn)
  map.put("homeMenuAboutMet", Res.string.homeMenuAboutMet)
  map.put("homeMenuAboutPhotography", Res.string.homeMenuAboutPhotography)
  map.put("homeMenuAboutPublic", Res.string.homeMenuAboutPublic)
  map.put("homeMenuAboutRepo", Res.string.homeMenuAboutRepo)
  map.put("homeMenuAboutSource", Res.string.homeMenuAboutSource)
  map.put("homeMenuAboutUnsplash", Res.string.homeMenuAboutUnsplash)
  map.put("homeMenuAboutWonderous", Res.string.homeMenuAboutWonderous)
  map.put("homeMenuButtonAbout", Res.string.homeMenuButtonAbout)
  map.put("homeMenuButtonExplore", Res.string.homeMenuButtonExplore)
  map.put("homeMenuButtonView", Res.string.homeMenuButtonView)
  map.put("homeSemanticOpenMain", Res.string.homeSemanticOpenMain)
  map.put("homeSemanticWonder", Res.string.homeSemanticWonder)
  map.put("introDescriptionLearn", Res.string.introDescriptionLearn)
  map.put("introDescriptionNavigate", Res.string.introDescriptionNavigate)
  map.put("introDescriptionUncover", Res.string.introDescriptionUncover)
  map.put("introSemanticEnterApp", Res.string.introSemanticEnterApp)
  map.put("introSemanticNavigate", Res.string.introSemanticNavigate)
  map.put("introSemanticSwipeLeft", Res.string.introSemanticSwipeLeft)
  map.put("introSemanticWonderous", Res.string.introSemanticWonderous)
  map.put("introTitleDiscover", Res.string.introTitleDiscover)
  map.put("introTitleExplore", Res.string.introTitleExplore)
  map.put("introTitleJourney", Res.string.introTitleJourney)
}
